/*
 * Purpose: Zod schema for L1 outcome interpretation (before full plan)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 98
 */
import { z } from 'zod';
import { MISSION_REQUEST_FIELD_TYPES } from '@/services/mission-knowledge/types';

const missionFieldSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  type: z.enum(MISSION_REQUEST_FIELD_TYPES),
  placeholder: z.string().optional(),
  helpText: z.string().optional(),
  required: z.boolean().optional(),
  options: z.array(z.string()).optional(),
  storage: z.enum(['mission', 'vault']).optional(),
  vaultSecretName: z.string().optional(),
  maxRating: z.number().int().min(2).max(10).optional(),
  body: z.string().optional(),
});

export const intentInterpretationSchema = z.object({
  interpretedGoal: z.string().min(1),
  confidence: z.number().min(0).max(1),
  suggestedComposeMode: z.enum(['express', 'guided']).optional(),
  assumptions: z.array(z.string()).default([]),
  gaps: z.array(z.string()).default([]),
  needsGmail: z.boolean().optional(),
  needsLinkedIn: z.boolean().optional(),
  needsOpenAi: z.boolean().optional(),
  matchedTemplateHint: z.string().optional(),
  knowledgeRequests: z
    .array(
      z.object({
        id: z.string().min(1),
        gapRef: z.string().min(1),
        title: z.string().min(1),
        description: z.string().optional(),
        layout: z.enum(['form', 'callout']).optional(),
        fields: z.array(missionFieldSchema),
      })
    )
    .optional(),
});

export type IntentInterpretationPayload = z.infer<typeof intentInterpretationSchema>;
